import { Component, h, Host, Prop } from '@stencil/core';
import { pathStore } from '@store/path-store';

@Component({
  tag: 'rp-badge',
  styleUrl: 'rp-badge.scss',
  shadow: true
})
export class RpBadge {
  @Prop() rpValue!: string;
  render() {
    const assetPath = pathStore.assetPath;
    return (
      <Host>
        <slot>
          <div
            class="h-9 w-9 font-bold text-xs leading-4 tracking-normal text-center text-white flex items-center justify-center bg-no-repeat bg-center bg-cover"
            style={{ backgroundImage: `url(${assetPath}images/RP_bg.svg)` }}
          >
            {this.rpValue}
          </div>
        </slot>
      </Host>
    );
  }
}
